import React from 'react';

const iconProps = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1.5'
};

export const renderMarketingIcon = (icon, size = 32, color = 'currentColor') => {
    const props = { ...iconProps, width: size, height: size, viewBox: '0 0 24 24', stroke: color };

    switch (icon) {
        case 'bolt':
            return (
                <svg {...props}>
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                </svg>
            );
        case 'warning':
            return (
                <svg {...props}>
                    <path d="M12 2L1 21h22L12 2z" />
                    <path d="M12 9v4" />
                    <circle cx="12" cy="17" r="0.5" fill={color} />
                </svg>
            );
        case 'shield':
            return (
                <svg {...props}>
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    <path d="M9 12l2 2 4-4" />
                </svg>
            );
        case 'globe':
            return (
                <svg {...props}>
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                </svg>
            );
        case 'fire':
            return (
                <svg {...props}>
                    <path d="M12 2c1.5 2 3 4.5 3 7a3 3 0 1 1-6 0c0-2.5 1.5-5 3-7z" />
                    <path d="M12 12c2 2 4 5 4 8a4 4 0 1 1-8 0c0-3 2-6 4-8z" />
                </svg>
            );
        case 'smoke':
            return (
                <svg {...props}>
                    <path d="M17 8C8 10 5.9 16.17 3.82 21.34L2 17l3.5-1L4 11l4 1-1-4 4.5 1L10 4l5 2-1-3 3 1" />
                </svg>
            );
        case 'time':
            return (
                <svg {...props}>
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 6v6l4 2" />
                </svg>
            );
        case 'home':
            return (
                <svg {...props}>
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
            );
        case 'arrow':
            return (
                <svg {...props}>
                    <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
            );
        case 'bulb':
            return (
                <svg {...props}>
                    <path d="M9 18h6M10 22h4" />
                    <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
                </svg>
            );
        case 'star':
            return (
                <svg {...props}>
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
            );
        default:
            return (
                <svg {...props}>
                    <circle cx="12" cy="12" r="10" />
                </svg>
            );
    }
};
